module.exports = __webpack_public_path__ + "static/alistair-143a15d3b8c0a1fdd32b6c8573bb56ab.png";